import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
// import PrivateRoute from "../commons/PrivateRoute";
import React from "react";
import {
    ACCESS_TOKEN_STORED
} from "../constants";
import { NotFound } from "../pages/notFound";
import ForgotPassword from "./../pages/auth/forgotPassword";
import Login from "./../pages/auth/login";
// import Register from "./../pages/auth/register";
import Dashboard from "./../pages/dashboard";
import Media from "./../pages/media";
import Setting from "./../pages/setting";
import NewsList from "./../pages/news/list";
import ContactList from './../pages/contact/list';
import BrandList from './../pages/brand/list';
import BannerList from './../pages/banner/list';
import UserList from './../pages/user/list';
import ActionBanner from './../pages/banner/action';
import ActionBrand from './../pages/brand/action';
import ActionNews from './../pages/news/action';
import Investor from './../pages/investor/action';
import JobList from './../pages/address/list';
import ListApply from './../pages/address/list-apply';
import DetailApply from './../pages/address/list-apply/detail.jsx';
import AddressAction from './../pages/address/action';
import EditNews from "./../pages/news/action";
import EditBrand from './../pages/brand/edit';
import EditBanner from './../pages/banner/edit';
import EditAddress from './../pages/address/edit';
import EditProfile from './../pages/profile/edit';
import AddBannerInvestor from './../pages/investor/Banner/Banner';
import Thongdiep from './../pages/investor/thong-diep';
import Doingu from './../pages/investor/doi-ngu/list';
import DoinguAdd from './../pages/investor/doi-ngu/action';
import TuyenSinh from './../pages/tuyen-sinh/action';
import HoiDap from './../pages/tuyen-sinh/hoi-dap';
import HoiDapAction from '../pages/tuyen-sinh/hoi-dap-action';
import ChuongTrinh from './../pages/tuyen-sinh/chuong-trinh';
import ChuongTrinhAction from './../pages/tuyen-sinh/chuong-trinh-action';
import WhyChoose from './../pages/why/action';
import ChamSoc from './../pages/why/cham-soc';
import About from './../pages/about/action';
import QuangTri from './../pages/quangTri/action';
import Translate from "./../pages/translate";
import MenuList from "./../pages/menu/list";

import NangKhieu from './../pages/why/nang-khieu';
import NangKhieuEdit from './../pages/why/nang-khieu-edit';

import ActionAboutProduct from './../pages/aboutProduct/action';
import ListAboutProduct from './../pages/aboutProduct/list';
import EditAboutProduct from './../pages/aboutProduct/edit';

import ActionInfrastructure from './../pages/aboutInfrastructure/action';
import ListInfrastructure from './../pages/aboutInfrastructure/list';
import EditInfrastructure from './../pages/aboutInfrastructure/edit';

import ActionWhyInvestment from './../pages/whyInvestment/action';
import ListWhyInvestment from './../pages/whyInvestment/list';
import EditWhyInvestment from './../pages/whyInvestment/edit';

import ActionQuangTriMaterials from './../pages/quangTriMaterials/action';
import ListQuangTriMaterials from './../pages/quangTriMaterials/list';
import EditQuangTriMaterials from './../pages/quangTriMaterials/edit';
import ContactDetail from './../pages/contact/detail';
import axios from "axios";

const PrivateRoute = ({ children }) => {
    axios.get('/admin/auth').then((data) => {
        console.log('data', data.data.status_code)
        if(data.data.status_code !== 200){
            localStorage.setItem(ACCESS_TOKEN_STORED, '')
        }
    })
    // return  <Navigate to="/login" />;
    return localStorage.getItem(ACCESS_TOKEN_STORED) ? children : <Navigate to="/login" />;
};

const PrivateRouteLogin = ({ children }) => {
    return localStorage.getItem(ACCESS_TOKEN_STORED) ? <Navigate to="/" /> : children;
};

const appRouter = () => {
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <BrowserRouter>
            <Routes >
                <Route path="/" element={<PrivateRoute> <BannerList /></PrivateRoute>} />
                <Route path="/login" element={<PrivateRouteLogin><Login /> </PrivateRouteLogin>} exact={true} />
                {/* <Route path="/register" element={<Register />} exact={true} /> */}
                <Route path="/forgot-password" element={<ForgotPassword />} exact={true} />
                {/* <Route path="/dashboard" element={<Dashboard />} exact={true}/> */}
                <Route path="/dashboard" element={<PrivateRoute> <BannerList /> </PrivateRoute>} exact={true} />
                <Route path="/news/add" element={<PrivateRoute><ActionNews /></PrivateRoute>} exact={true} />
                <Route path="/media/list" element={<PrivateRoute><Media /></PrivateRoute>} />
                <Route path="/contact/list" element={<PrivateRoute><ContactList /></PrivateRoute>} exact={true} />
                <Route path="/investor/edit/:id" element={<PrivateRoute><Investor /></PrivateRoute>} />
                <Route path="/media/add" element={<PrivateRoute><Dashboard /></PrivateRoute>} exact={true} />
                <Route path="/news/list" element={<PrivateRoute><NewsList /></PrivateRoute>} exact={true} />
                <Route path="/word/list" element={<Dashboard />} exact={true} />
                <Route path="/word/add" element={<PrivateRoute><NewsList /></PrivateRoute>} exact={true} />
                <Route path="/block/list" element={<PrivateRoute><BannerList /></PrivateRoute>} exact={true} />
                <Route path="/block/add" element={<PrivateRoute><ActionBanner /></PrivateRoute>} exact={true} />
                <Route path="/block/edit/:id" element={<PrivateRoute><EditBanner /></PrivateRoute>} exact={true} />
                <Route path="/brand/list" element={<PrivateRoute><BrandList /></PrivateRoute>} exact={true} />
                <Route path="/brand/add" element={<PrivateRoute><ActionBrand /></PrivateRoute>} exact={true} />
                <Route path="/brand/edit/:id" element={<PrivateRoute><EditBrand /></PrivateRoute>} exact={true} />
                <Route path="/setting/detail" element={<PrivateRoute><Setting /></PrivateRoute>} exact={true} />
                <Route path="/user/list" element={<PrivateRoute><UserList /></PrivateRoute>} exact={true} />
                <Route path="/news/edit/:id" element={<PrivateRoute><EditNews /></PrivateRoute>} exact={true} />
                <Route path="/tuyen-dung/list" element={<PrivateRoute><JobList /></PrivateRoute>} exact={true} />
                <Route path="/tuyen-dung/list-apply" element={<PrivateRoute><ListApply /></PrivateRoute>} exact={true} />
                <Route path="/tuyen-dung/detail/:id" element={<PrivateRoute><DetailApply /></PrivateRoute>} exact={true} />
                <Route path="/tuyen-dung/add" element={<PrivateRoute><AddressAction /></PrivateRoute>} exact={true} />
                <Route path="/tuyen-dung/edit/:id" element={<PrivateRoute><AddressAction /></PrivateRoute>} exact={true} />
                <Route path="/profile/edit/:id" element={<PrivateRoute><EditProfile /></PrivateRoute>} exact={true} />
                <Route path="/investor/banner" element={<PrivateRoute><AddBannerInvestor /></PrivateRoute>} exact={true} />
                <Route path="/investor/thong-diep" element={<PrivateRoute><Thongdiep /></PrivateRoute>} exact={true} />
                <Route path="/investor/doi-ngu" element={<PrivateRoute><Doingu /></PrivateRoute>} exact={true} />
                <Route path="/doi-ngu/add" element={<PrivateRoute><DoinguAdd /></PrivateRoute>} exact={true} />
                <Route path="/doi-ngu/edit/:id" element={<PrivateRoute><DoinguAdd /></PrivateRoute>} exact={true} />
                <Route path="/tuyen-sinh/action/:id" element={<PrivateRoute><TuyenSinh /></PrivateRoute>} exact={true} />
                <Route path="/tuyen-sinh/hoi-dap" element={<PrivateRoute><HoiDap /></PrivateRoute>} exact={true} />
                <Route path="/tuyen-sinh/hoi-dap/add" element={<PrivateRoute><HoiDapAction /></PrivateRoute>} exact={true} />
                <Route path="/tuyen-sinh/hoi-dap/action/:id" element={<PrivateRoute><HoiDapAction /></PrivateRoute>} exact={true} />
                <Route path="/tuyen-sinh/chuong-trinh" element={<PrivateRoute><ChuongTrinh /></PrivateRoute>} exact={true} />
                <Route path="/tuyen-sinh/chuong-trinh/add" element={<PrivateRoute><ChuongTrinhAction /></PrivateRoute>} exact={true} />
                <Route path="/tuyen-sinh/chuong-trinh/action/:id" element={<PrivateRoute><ChuongTrinhAction /></PrivateRoute>} exact={true} />

                <Route path="/why-choose/tam-ly/:id" element={<PrivateRoute><WhyChoose /></PrivateRoute>} />
                <Route path="/why-choose/cham-soc/:id" element={<PrivateRoute><ChamSoc /></PrivateRoute>} />
                <Route path="/why-choose/nang-khieu/add" element={<PrivateRoute><NangKhieuEdit /></PrivateRoute>} />
                <Route path="/why-choose/nang-khieu/edit/:id" element={<PrivateRoute><NangKhieuEdit /></PrivateRoute>} />
                <Route path="/why-choose/nang-khieu" element={<PrivateRoute><NangKhieu /></PrivateRoute>} />

                <Route path="/about/edit/:id" element={<PrivateRoute><About /></PrivateRoute>} />
                <Route path="/translate/" element={<PrivateRoute><Translate /></PrivateRoute>} />
                <Route path="/menu" element={<PrivateRoute><MenuList /></PrivateRoute>} />

                <Route path="/about/product/list" element={<PrivateRoute>< ListAboutProduct /></PrivateRoute>} exact={true} />
                <Route path="/about/product/add" element={<PrivateRoute><ActionAboutProduct /></PrivateRoute>} exact={true} />
                <Route path="/about/product/edit/:id" element={<PrivateRoute><EditAboutProduct /></PrivateRoute>} exact={true} />

                <Route path="/about/infrastructure/list" element={<PrivateRoute><ListInfrastructure /></PrivateRoute>} exact={true} />
                <Route path="/about/infrastructure/add" element={<PrivateRoute><ActionInfrastructure /></PrivateRoute>} exact={true} />
                <Route path="/about/infrastructure/edit/:id" element={<PrivateRoute><EditInfrastructure /></PrivateRoute>} exact={true} />

                <Route path="/about/project/list" element={<PrivateRoute><ListWhyInvestment /></PrivateRoute>} exact={true} />
                <Route path="/about/project/add" element={<PrivateRoute><ActionWhyInvestment /></PrivateRoute>} exact={true} />
                <Route path="/about/project/edit/:id" element={<PrivateRoute><EditWhyInvestment /></PrivateRoute>} exact={true} />

                <Route path="/quang-tri/edit/:id" element={<PrivateRoute><QuangTri /></PrivateRoute>} />

                <Route path="/quang-tri/materials/list" element={<PrivateRoute><ListQuangTriMaterials /></PrivateRoute>} exact={true} />
                <Route path="/quang-tri/materials/add" element={<PrivateRoute><ActionQuangTriMaterials /></PrivateRoute>} exact={true} />
                <Route path="/quang-tri/materials/edit/:id" element={<PrivateRoute><EditQuangTriMaterials /></PrivateRoute>} exact={true} />
                <Route path="/contact/detail/:id" element={<PrivateRoute><ContactDetail /></PrivateRoute>} exact={true} />

                <Route path="*" element={<PrivateRoute><NotFound /></PrivateRoute>} exact={true} />
            </Routes>
        </BrowserRouter>
    );
};

export default appRouter;
